/* eslint-disable import/prefer-default-export */
import React from 'react'
import { SvgIconProps } from './SvgIconProps'

export const Close: React.FC<SvgIconProps> = ({ size = '24px', color = 'currentColor' }) => {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.55806 5.55806C5.80214 5.31398 6.19786 5.31398 6.44194 5.55806L12 11.1161L17.5581 5.55806C17.8021 5.31398 18.1979 5.31398 18.4419 5.55806C18.686 5.80214 18.686 6.19786 18.4419 6.44194L12.8839 12L18.4419 17.5581C18.686 17.8021 18.686 18.1979 18.4419 18.4419C18.1979 18.686 17.8021 18.686 17.5581 18.4419L12 12.8839L6.44194 18.4419C6.19786 18.686 5.80214 18.686 5.55806 18.4419C5.31398 18.1979 5.31398 17.8021 5.55806 17.5581L11.1161 12L5.55806 6.44194C5.31398 6.19786 5.31398 5.80214 5.55806 5.55806Z"
      fill={color}
      stroke={color}
      strokeWidth="0.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
}
